import type { FocusEventHandler, MutableRefObject } from "react";

/**
 * Helper function to wrap blur handler. It allows us to detect when the wrapper and children lose focus (deep blur)
 */
const createBlurHandler =
  (
    ref: MutableRefObject<HTMLElement | null>,
    callback: FocusEventHandler<HTMLElement>,
  ): FocusEventHandler<HTMLElement> =>
  (event) => {
    const newTargetElement = (event.relatedTarget ||
      document.activeElement) as HTMLElement;

    // IE-specific check, please refer to https://github.com/facebook/react/issues/3751
    if (ref.current && !ref.current.contains(newTargetElement)) {
      callback(event);
    }
  };

export { createBlurHandler };
